const wrappedLocalStorage = {
    key: (index) => localStorage.key(index),
    clear: () => {
        localStorage.clear();
    },
    removeItem: (key) => {
        localStorage.removeItem(key);
    },
    getItem: (key) => localStorage.getItem(key),
    setItem: (key, value) => {
        try {
            localStorage.setItem(key, value);
        } catch (error) {
            const dataLength = `${value}`.length;
            const errorMessage = `Failed to set ${key}, of length ${dataLength}, in localStorage. ${error}`;
            console.error(errorMessage);
        }
    },
    isSet: (key) => localStorage.getItem(key) !== null,
};

export default wrappedLocalStorage;
